var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInvitefriends = function SvgInvitefriends(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.513
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.335 9.402c.104 0 .205.027.294.08l6.894 4.075 7.833-4.066a.577.577 0 0 1 .453-.071c.407.355.434.456.434.56v6.685a.577.577 0 0 1-.578.578H2.335a.577.577 0 0 1-.579-.578V9.98a.577.577 0 0 1 .579-.578ZM7.601 7.733h4.69M9.946 9.982V5.484M3.7 7.317V4.295C3.7 3.58 4.229 3 4.881 3H15.12c.652 0 1.181.58 1.181 1.295v3.022"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.335 8.645c.239 0 .474.064.68.186l6.532 3.86a.89.89 0 0 0 .906 0l6.533-3.86A1.335 1.335 0 0 1 19 9.98v6.685c0 .737-.598 1.335-1.335 1.335H2.335A1.335 1.335 0 0 1 1 16.665V9.98c0-.737.598-1.335 1.335-1.335Zm15.152 1.646-6.264 3.703c-.7.414-1.559.444-2.281.089l-.165-.089-6.264-3.702v6.195h14.974v-6.196Zm-6.785-4.807v1.492h1.589V8.49h-1.589v1.493H9.19V8.489H7.601V6.976H9.19V5.484h1.513Zm4.417-3.24c1.037 0 1.86.85 1.932 1.9l.006.151v3.022h-1.513V4.295c0-.277-.164-.487-.353-.53l-.072-.009H4.88c-.194 0-.378.18-.417.438l-.008.101v3.022H2.944V4.295c0-1.067.776-1.966 1.792-2.046l.146-.006H15.12Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
};
export default SvgInvitefriends;